import React from 'react';
import { Card, Typography, Loader } from '@design-system/index';
import '../../DetailsPage.scss';
import { useDetailsDocumentsVM } from './useDetailsDocumentsVM';
import { FileUpload } from '@components/FileUpload/FileUpload';
import { CdnFile } from '@services/core/cdn/file/file';

export default function DetailsDocuments() {
    const { isLoading, isError, documents, handleDeleteDocument, handlePostDocument } = useDetailsDocumentsVM();

    if (isLoading) {
        return <Loader className="full-container-loader" />;
    }

    if (isError) {
        return (
            <Typography intrinsic="p" color="secondary">
                Une erreur est survenue lors de la récupération des documents de la fiche logement
            </Typography>
        );
    }

    return (
        <div className="details-apartment-container">
            <div className="details-apartment-container-body">
                <Card headerType="very-light" headerTitle="Documents">
                    <FileUpload
                        width="100%"
                        height="214px"
                        isMultiple={true}
                        isImage={false}
                        table={true}
                        accept="application/pdf"
                        files={documents}
                        onOneSuccess={(file: CdnFile) => {
                            handlePostDocument(file);
                        }}
                        onOneDelete={(file: CdnFile) => {
                            handleDeleteDocument(file.id.toString());
                        }}
                    />
                </Card>
            </div>
        </div>
    );
}
